import type { HttpAdapter } from "../../core/adapters/axios.adapter";
import type { GraphDataObjectV2, GraphDataObjectV1 } from "../historical-charts/data/data-object/graph";
import { chartFromGraphDataObjectV1, chartFromGraphDataObjectV2 } from "../historical-charts/data/transforms/transformers/charts";
import { Chart } from "../historical-charts/models/charts/chart";
import { ChartType } from "../historical-charts/models/charts/chart-type.enum";
import { newApiChartTypes } from "../historical-charts/options/lightweight-charts/chart-type-options.map";

export class ChartService {
  constructor(private httpAdapter: HttpAdapter, private legacyAdapter: HttpAdapter) { }

  async load(chart: Chart | string): Promise<any> {
    const chartId = typeof chart === 'string' ? chart : chart.type; 
    const legacy = !newApiChartTypes.includes(chartId as ChartType);

    if (typeof chart === 'string') { 
      const response = await this.legacyAdapter.get(chart); 
      return response.data;
    }

    if (legacy) {
      const response = await this.legacyAdapter.get<GraphDataObjectV1>(`${chart.type}/data?time_range=${chart.timeRange}`);
      const loadedChart = chartFromGraphDataObjectV1(chart, response.data);
      return loadedChart; 
    } else {
      const response = await this.httpAdapter.get<GraphDataObjectV2>(`${chartId}?time_range=${chart.timeRange}`);
      const loadedChart = chartFromGraphDataObjectV2(chart, response.data);
      return loadedChart;
    }
  }

  async loadV2(chartId: string): Promise<any> {
    const response = await this.httpAdapter.get<GraphDataObjectV2>(chartId);
    return response.data;
  } 
}